import styled from 'styled-components';
import {
  Modal as SemanticModal,
} from 'semantic-ui-react';
import {
  Button,
  Header,
  Text as CustomText,
} from '@playbookux/playbook-web-core';

export const Modal = styled(SemanticModal)`
  padding: 30px;
  max-width: 600px;
`;

export const ContainerHeader = styled.div`
  display: flex;
  margin-bottom: 25px;
`;

export const ContainerContent = styled.div`
    margin: 10px 0;
`;

export const ContainerFooter = styled.div`
  display: flex;
  margin-top: 15px;
  justify-content: space-between;
`;

export const ContainerInputText = styled.div`
  display: flex;
`;

export const ContainerListCategories = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap
`;

export const Title = styled(Header)``;

export const Text = styled(CustomText.Bold)`
  && {
    margin: 10px 0;
    margin-right: ${({ marginRight }) => (marginRight ? '10px' : '')};
  }
`;

export const TextError = styled(CustomText.Error)``;

export const TextAlternative = styled(CustomText)`
  && {
    color: ${(props) => props.theme.color.flagText};
    max-width: 120px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const MergeButton = styled(Button)``;
